import React, { useEffect, useState } from "react";
import { decodeHtml, checkURL } from "../../../../assests/extention/commonfunction";
import ReactSelect from "react-select";
import { ModalBody } from "reactstrap";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";
import { currentYear } from "../../../Common/FewCommonMethods";

import AsteriskLabel from "../../../Common/AsteriskLabel";
import OnlyYearRange from "../../../Common/OnlyYearRange";
import YearRange from "../../../Common/YearRange";

const validationSchema = Yup.object().shape({
  designation: Yup.string().required("Designation is required"),
  company: Yup.string().required("Company name is required"),
  from_year: Yup.date()
    .required("From date is required")
    .typeError("Please enter a valid date")
    .max(new Date(), "From date cannot be in the future"),
  to_year: Yup.date()
    .nullable()
    .typeError("Please enter a valid date")
    .test("is-greater", "To date must be after from date", function (value) {
      const { from_year } = this.parent;
      if (!from_year || !value) return true;
      return new Date(value) > new Date(from_year);
    }),
});

export default function ProfileModelEmployment({
  edittype,
  formData,
  setFormData,
  setModelEmployment,
}) {
  const [formData1, setFormData1] = useState(formData);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [updateIndex, setUpdateIndex] = useState(null);
  const dispatch = useDispatch();

  // Helper function to format date for storage
  const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Helper function to format date for input field
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const strDate = String(dateString);
    if (strDate.includes("-") && strDate.split("-").length === 3) {
      return strDate;
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formik = useFormik({
    initialValues: {
      designation: "",
      company: "",
      from_year: "",
      to_year: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const formattedValues = {
        ...values,
        from_year: formatDateForStorage(values.from_year),
        to_year: formatDateForStorage(values.to_year),
      };

      setFormData1((prevData) => {
        const updatedExp = Array.isArray(prevData.experience)
          ? [...prevData.experience]
          : [];
        if (updateIndex !== null) {
          updatedExp[updateIndex] = formattedValues;
        } else {
          updatedExp.push(formattedValues);
        }
        return { ...prevData, experience: updatedExp };
      });
      closeForm();
    },
  });

  const openForm = (index = null) => {
    if (index !== null) {
      setUpdateIndex(index);
      const edu = formData1.experience[index];
      formik.setValues({
        id: edu.id,
        designation: edu.designation,
        company: edu.company,
        from_year: formatDateForInput(edu.from_year),
        to_year: formatDateForInput(edu.to_year),
      });
    } else {
      setUpdateIndex(null);
      formik.resetForm();
    }
    setIsFormVisible(true);
  };

  const closeForm = () => {
    setIsFormVisible(false);
    setUpdateIndex(null);
    formik.resetForm();
  };

  const deleteexperience = (index, item1) => {
    if (edittype == 1) {
      setFormData1((prevData) => ({
        ...prevData,
        experience: prevData.experience.map((item, i) =>
          i == index ? { ...item, status: 3 } : item1?.id == item?.id ? { ...item, status: 3 } : item
        ),
      }));
    } else {
      setFormData1((prevData) => ({
        ...prevData,
        experience: prevData.experience.filter((_, i) => i != index),
      }));
    }
  };

  const SubmitandNext = () => {
    if (formData1.experience?.length > 0) {
      if (edittype == 1) {
        const allInactive = formData1.experience.every((item) => item.status == 3);
        if (allInactive) {
          formik.setFieldError("experience", "At least add one experience");
          return;
        }

        setFormData((prevData) => ({
          ...prevData,
          experience: [...formData1.experience],
        }));
        const data = {
          type: "experience",
          experience: [...formData1.experience],
        };
        dispatch(updateProfile(data));
        setModelEmployment(false);
      } else {
        setFormData((prevData) => ({
          ...prevData,
          experience: [...formData1?.experience],
        }));
        setModelEmployment(false);
      }
      closeForm();
    } else {
      formik.setFieldError("experience", "At least add one experience");
    }
  };

  useEffect(() => {
    if (formData1.experience) {
      formik.setFieldError("experience", null);
    }
  }, [formData1.experience]);

  return (
    <>
      <button
        onClick={() => setModelEmployment((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <div>
          <div className="">
            <h6 className="add-edu">Experience</h6>
            <div className="row education-row">
              {Array.isArray(formData1.experience) &&
                formData1?.experience
                  .filter((item) => !(edittype === 1 && item.status === 3))
                  .map((item, index) => (
                    <div className=" col-md-4" key={index}>
                      <div className="add-education-wrapper">
                        <div className="add-first">
                          <div>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/bag.svg`}
                              alt=""
                            />
                          </div>
                          <div>
                            <h2>
                              {decodeHtml(item.designation)} - {decodeHtml(item.company)}
                            </h2>
                            <p>
                              <YearRange
                                fromYear={item.from_year}
                                toYear={item.to_year || "Present"}
                              />
                            </p>
                          </div>
                        </div>
                        <div className="add-button-education">
                          <button
                            className=""
                            onClick={() => deleteexperience(index, item)}
                          >
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                              alt=""
                            />
                          </button>
                          <button className="" onClick={() => openForm(index)}>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                              alt=""
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
            </div>

            {formik.errors.experience && (
              <p style={{ color: "red" }}>{formik.errors.experience}</p>
            )}
            <button
              className="buttons border-button mt-3 mb-4"
              onClick={() => openForm()}
            >
              Add More
            </button>
          </div>
          {isFormVisible && (
            <div className="add-experience-modal">
              <div className="">
                <form onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <h6 className="add-edu">
                        {updateIndex !== null ? "Edit" : "Add"} experience
                      </h6>
                      <div className="row">
                        <div className="form-group col-md-12">
                          <label className="label">
                            Designation <AsteriskLabel />
                          </label>
                          <input
                            type="text"
                            name="designation"
                            className="form-control"
                            placeholder="Enter designation"
                            value={decodeHtml(formik.values.designation)}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.designation &&
                            formik.errors.designation && (
                              <div style={{ color: "red" }}>
                                {decodeHtml(formik.errors.designation)}
                              </div>
                            )}
                        </div>
                        <div className="form-group col-md-12">
                          <label className="label">
                            Company <AsteriskLabel />
                          </label>
                          <input
                            type="text"
                            name="company"
                            className="form-control"
                            placeholder="Company name"
                            value={formik.values.company}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.company && formik.errors.company && (
                            <div style={{ color: "red" }}>
                              {formik.errors.company}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <h4 className="add-edu">Dates Attended</h4>
                      <div className="row mt-4">
                        <div className="form-group col-md-6">
                          <label className="label">
                            From <AsteriskLabel />
                          </label>
                          <input
                            type="date"
                            name="from_year"
                            className="form-control"
                            value={formik.values.from_year}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            max={new Date().toISOString().split("T")[0]}
                          />
                          {formik.touched.from_year &&
                            formik.errors.from_year && (
                              <div style={{ color: "red" }}>
                                {formik.errors.from_year}
                              </div>
                            )}
                        </div>
                        <div className="form-group col-md-6">
                          <label className="label">
                            To <AsteriskLabel />
                          </label>
                          <input
                            type="date"
                            name="to_year"
                            className="form-control"
                            value={formik.values.to_year}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            max={new Date().toISOString().split("T")[0]}
                          />
                          {formik.touched.to_year && formik.errors.to_year && (
                            <div style={{ color: "red" }}>
                              {formik.errors.to_year}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="add-btn">
                    <button type="submit" className="buttons background-button">
                      {updateIndex !== null ? "Update" : "Add"} experience
                    </button>
                    {updateIndex !== null && (
                      <p style={{ color: "green" }}>First Update then save</p>
                    )}
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </ModalBody>
      {!isFormVisible && (       
        <div className="modal-footer mt-3">
          <button className="btn  w-25" onClick={SubmitandNext}>
            Save
          </button>
        </div>
      )}
    </>
  );
}

// IDE bust cache 2

// PREEMPTIVE HMR BURST
